/* GASSISA
=========================================================================================
* Descripción: Dialog aditivo para solicitar acceso a otra licencia con el mismo equipo.
*              Reusa fingerprint/machineName de PrinterTools (mismos datos de ingreso).
* Historial:
*      1 | 08/10/2026 | LIC. José Luis Aragón C. | Creación multi-tenant aditiva
=========================================================================================
*/

import { useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { useSesion } from "../../context/System/SesionContext";

export default function RequestAdditionalAccessDialog({ open, onClose, onDone }) {
  const { requestAdditionalTenantAccess } = useSesion();
  const [form, setForm] = useState({ licenseGuid: "", adminName: "", adminEmail: "", deviceAlias: "" });
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((c) => ({ ...c, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);
    const result = await requestAdditionalTenantAccess?.(form);
    setLoading(false);
    if (!result?.ok) {
      setMessage(result?.message ?? "No fue posible enviar la solicitud.");
      return;
    }
    onDone?.(result);
    onClose?.();
  };

  const handleClose = () => {
    if (loading) return;
    setMessage("");
    onClose?.();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <form noValidate onSubmit={handleSubmit}>
        <DialogTitle sx={{ fontWeight: "bold" }}>Solicitar acceso a otra licencia</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Se usará la huella y nombre de este equipo (PrinterTools) para pedir acceso. Al ser aprobada aparecerá como empresa disponible en el login.
          </Typography>
          {message && (
            <Alert severity="warning" sx={{ mb: 2 }}>
              {message}
            </Alert>
          )}
          <TextField name="licenseGuid" label="Licencia ARXS-XXXX-XXXX-XXXX" value={form.licenseGuid} onChange={handleChange} fullWidth margin="dense" autoComplete="off" placeholder="ARXS-0000-0000-0000" />
          <TextField name="adminName" label="Nombre administrador" value={form.adminName} onChange={handleChange} fullWidth margin="dense" autoComplete="off" />
          <TextField name="adminEmail" label="Correo administrador" value={form.adminEmail} onChange={handleChange} fullWidth margin="dense" autoComplete="off" />
          <TextField name="deviceAlias" label="Alias del equipo (opcional)" value={form.deviceAlias} onChange={handleChange} fullWidth margin="dense" autoComplete="off" helperText="Si se deja vacío se usa el nombre del equipo." />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} disabled={loading}>
            Cancelar
          </Button>
          <Button type="submit" variant="contained" disabled={loading}>
            Solicitar acceso
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
